import { Button, CircularProgress, InputAdornment, Modal, TextField } from "@material-ui/core";

import { default as cn } from "./SuspendPatrolModal.scss";


interface SuspendPatrolModalProps {
    handleSuspend: (arg: number) => void;
    handleInput: (arg: string) => void;
    handleVisible: (arg: boolean) => void;
    streamingId?: number;
    duration: string;
    visible: boolean;
    isProcessing?: boolean;
}

function SuspendPatrolModal(props: SuspendPatrolModalProps) {
    const { handleInput, handleSuspend, handleVisible, streamingId, duration, visible, isProcessing } = props;

    return (
        <Modal className={cn.modal} onClose={() => handleVisible(false)} open={visible}>
            <div className={cn.modalContent}>
                <h2>Suspend Patrol</h2>
                <TextField
                    id={"streaming_suspend-patrol-modal_duration-input"}
                    InputProps={{
                        endAdornment: <InputAdornment position="end">minutes</InputAdornment>,
                    }}
                    onChange={(e) => handleInput(e.target.value)}
                    className={cn.duration}
                    value={duration}
                    color="primary"
                    label="Duration"
                    variant="outlined"
                />
                <div className={cn.buttons}>
                    {isProcessing ?
                        <Button color="secondary" variant="outlined">
                            <CircularProgress color="secondary" size={22} />
                        </Button>
                        :
                        <Button
                            id={"streaming_suspend-patrol-modal_confirm-button"}
                            onClick={() => handleSuspend(streamingId || 0)}
                            color="secondary"
                            variant="contained"
                        >
                            Confirm
                        </Button>
                    }
                    <Button
                        id={"streaming_suspend-patrol-modal_cancel-button"}
                        onClick={() => handleVisible(false)}
                        color="inherit"
                        variant="contained"
                    >
                        Cancel
                    </Button>
                </div>
            </div>
        </Modal>
    );
}

export default SuspendPatrolModal;
